import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GlassMasthead } from "@/components/GlassMasthead";

export const EditionIndex = ({ pages, edition, lang }) => {
  const features = pages.filter((p) => !["ad", "cover", "contents", "portrait"].includes(p.template));
  return (
    <section className="px-6 sm:px-12 py-24" style={{ background: "var(--cream)", color: "var(--charcoal)" }} data-testid="edition-index">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="font-label uppercase" style={{ fontSize: 10, letterSpacing: "0.25em", color: "var(--bordeaux)" }}>{edition?.number} · {edition?.month}</div>
          <h2 className="font-head font-semibold mt-3" style={{ fontSize: "clamp(36px, 4vw, 60px)", lineHeight: 0.95 }}>{lang === "fr" ? "Page par page" : "Page by page"}</h2>
          <p className="mt-6 max-w-sm" style={{ lineHeight: 1.7, opacity: 0.8 }}>{edition?.deck}</p>
          <Link to={`/read/${lang}`} className="btn-bordeaux mt-8" data-testid="index-open-magazine">{edition?.ui?.open}</Link>
        </div>
        <div className="lg:col-span-8">
          {features.map((p, i) => (
            <motion.div key={p.n} initial={{ opacity: 0, x: 24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.6, delay: (i % 6) * 0.04 }}>
              <Link to={`/read/${lang}?p=${p.n}`} className="toc-row group" style={{ padding: "14px 0", borderColor: "rgba(25,25,25,0.15)" }} data-testid={`index-row-${p.n}`}>
                <span className="toc-num" style={{ fontSize: 26, width: 48 }}>{String(p.n).padStart(2, "0")}</span>
                <span className="flex-1 flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1">
                  <span className="font-head font-semibold" style={{ fontSize: 24, lineHeight: 1 }}>{p.title}</span>
                  <span className="font-label uppercase" style={{ fontSize: 9, letterSpacing: "0.22em", opacity: 0.6 }}>{edition?.sections?.[p.section]}</span>
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const LandingFooter = ({ edition, lang }) => (
  <footer className="px-6 sm:px-12 pt-24 pb-12 grain relative overflow-hidden" data-testid="landing-footer">
    <div className="text-center">
      <GlassMasthead text="ROOTS" dark className="text-[26vw] lg:text-[18vw]" style={{ lineHeight: 0.8 }} />
      <p className="font-head italic mt-6" style={{ fontSize: 22, color: "var(--platinum)" }}>{edition?.tagline}</p>
      <Link to={`/read/${lang}`} className="btn-bordeaux mt-10" style={{ padding: "16px 28px" }} data-testid="footer-open-magazine">{edition?.ui?.open}</Link>
    </div>
    <div className="silver-rule mt-20" style={{ opacity: 0.4 }} />
    <div className="flex flex-col sm:flex-row justify-between gap-3 mt-6 reader-label" style={{ opacity: 0.5 }}>
      <span>ROOTS · {edition?.number} · {edition?.title}</span>
      <span>{lang === "fr" ? "Musique · Écran · Style · Influence" : "Music · Screen · Style · Influence"}</span>
    </div>
  </footer>
);
